import React from 'react'

import cn from 'classnames'

import './index.scss'

const Modal = props => {
  return <div className={cn('modal-container', { show: props.show })}>
    <div className="overlay" onClick={ () => props.onClose() } />
    <div className="modal">
      {props.children}
    </div>
  </div>
}

Modal.defaultProps = {
  close: () => {}
}

export default Modal
